import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
     
    <div
      {...props}
      className={classes}
    >
     <h1 className="m-0" style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
          <Image
            src={require('./../../../assets/images/sees_emblem_gold.png')}
            alt="SeeS International"
            style={{ maxHeight: '46px', width: 'auto' }} />
          <span style={{ 
            fontFamily: '"Outfit", sans-serif', 
            fontWeight: '800', 
            fontSize: '18px', 
            letterSpacing: '1.5px', 
            color: '#A88756',
            textTransform: 'uppercase',
            lineHeight: '1.1'
          }}>
            SEES <span style={{ color: '#C5A477', fontWeight: '500', fontSize: '11px', display: 'block', letterSpacing: '2px', opacity: 0.9 }}>INTERNATIONAL</span>
          </span>
        </Link>
      </h1>
    </div>
  );
}

export default Logo;
